import React from "react";
import FounderCard from "./FounderCard";
import founder_3 from "../../assets/images/Chairman.jpg";
import founder_4 from "../../assets/images/Principal.jpg";
import "../Founders/FounderCard.css";

const Fcard = () => {
  return (
    <section className="founder-section">

      <div className="container-fluid px-3 px-md-4">

        <div className="row justify-content-center g-4">

          <div className="col-12 col-xl-11">
            <FounderCard
              header="CHAIRMAN & MANAGING DIRECTOR"
              image={founder_3}
              name="Mr. Sodhanshu Upadhyay"
              descr="Greeting to All, 'If a man does not know to what part he is steering no wind is favorable. This was said by the ancient philosopher, Sencea.'"
              cnt="O3"
            />
          </div>

          <div className="col-12 col-xl-11">
            <FounderCard
              header="PRINCIPAL"
              image={founder_4}
              name="Dr. K. K. Upadhyay"
              descr="Dear Parents, Greetings! School is the base of every child’s foundation, where he is nurtured with both love and care, to bloom into colorful blossom and spread its fragrance far and wide. A child what he learns in his early years of schooling, builds his character and personality, which later reflects in its entire life."
              cnt="O4"
            />
          </div>

        </div>

      </div>

    </section>
  );
};

export default Fcard;